/* eslint no-console: "off", quotes: "off" */
import { mapState, mapActions, mapMutations, mapGetters } from "vuex";
import ResumeGame from "@/components/home/modals/ResumeGame";
import ZeroBalance from '@/components/home/modals/ZeroBalance';
import ResubscribeGameSms from '@/components/home/modals/ResubscribeGameSms';
import ResubscribeGame from '@/components/home/modals/ResubscribeGame';
import Maintenance from '@/components/home/modals/shared/Maintenance';
import NoBalance from '@/components/home/modals/NoBalanceModal';
import PendingChallenge from '../../components/home/game/challenge/PendingChallenge';

const NewGameMixin = {
  methods: {
    ...mapMutations('common', [
      'storeModalForHomePage',
    ]),
    ...mapActions('game', [
      'checkIfGameToResumeExists',
    ]),
    ...mapActions('profile', [
      'checkCoreResponses',
    ]),
    playGame() {
      this.checkCoreResponses().then((response) => {
        if (response === 'CORE_IS_DOWN') {
          this.storeModalForHomePage(Maintenance);
        } else {
          this.checkIfGameToResumeExists().then(() => {
            const activeIntegrationConfig = this.getActiveIntegrationConfig;
            console.log('this.gameInProgress in Home js:', this.gameInProgress);
            if (this.gameInProgress) {
              console.log('showing resume game pop up in Home js...');
              this.storeModalForHomePage(ResumeGame);
            } else if (this.challengePending) {
              // a previous challenge still pending
              this.storeModalForHomePage(PendingChallenge);
            } else if (this.userDetails.availableGames === 0 && !this.userDetails.subscribed) {
              if (this.subAndUnsubViaSMS) {
                if (this.reoptinAndOptoutConfig === 'REOPTIN_SMS' || this.reoptinAndOptoutConfig === 'REOPTIN_OPTOUT_SMS') {
                  this.storeModalForHomePage(ResubscribeGameSms);
                } else {
                  this.storeModalForHomePage(ResubscribeGame);
                }
              } else {
                this.storeModalForHomePage(ResubscribeGame);
              }
            } else if (this.userDetails.availableGames === 0 && this.userDetails.subscribed) {
              this.storeModalForHomePage(ZeroBalance);
            } else if (activeIntegrationConfig && activeIntegrationConfig.hasNoBalance && this.userDetails.parked) {
              this.storeModalForHomePage(NoBalance);
            } else {
              this.$router.push('/searchingOpponent');
            }
          }).catch(error => console.error(error));
        }
      }).catch(error => console.error(error));
    },
  },
  computed: {
    ...mapState('game', [
      'gameInProgress',
      'challengePending',
    ]),
    ...mapState('common', [
      'userDetails',
      'subAndUnsubViaSMS',
      'reoptinAndOptoutConfig',
    ]),
    ...mapGetters('common', [
      'getActiveIntegrationConfig',
    ]),
  },
};

export default NewGameMixin;



// WEBPACK FOOTER //
// ./src/common/mixins/home.js